import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
// Entities
import { Company } from "@/entities/index";

@Component
export default class DashboardBO extends Vue {
  clients: Company[] = [];

  client = "";

  chart1 = true;
  chart2 = true;
  chart3 = true;
  chart4 = true;
  chart5 = true;

  async allClients(): Promise<void> {
    this.clients = (await axios.get(`/api/companies`)).data as Company[];
  }

  mounted(): void {
    this.allClients();
  }
}
